//---------- Compras -------------
import Solicitud_Compras_Servicio from "../../../views/administrador/Compras/Solicitud_Compras_Servicio";
import Solicitud_Compras from "../../../views/administrador/Compras/Solicitud_Compras";



const routes_compras = [
  {
    path: "/Solicitud_Compras_Servicio",
    name: "Solicitud de Compras Servicio",
    icon: "",
    component: Solicitud_Compras_Servicio,
    doNotShow: true,
  }, 
  {
    path: "/Solicitud_Compras",
    name: "Solicitud de Compra",
    icon: "",
    component: Solicitud_Compras,
    doNotShow: true,
  }, 
];

export default routes_compras;
